import React, { useState, useEffect } from 'react';

import Header from './components/Header';
import Hero from './sections/Hero';
import About from './sections/About';
import Experience from './sections/Experience';
import Projects from './sections/Projects';
import Skills from './sections/Skills';
import Contact from './sections/Contact';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';
    // src/index.js or src/App.js
import './index.css'; // Adjust path if needed



// --- Main App Component ---
export default function App() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const style = document.createElement('style');
        // --- INICIO DE LA EXPLICACIÓN DEL CSS ---
        // Todo el CSS personalizado de tu aplicación se inyecta aquí directamente en el <head> del HTML.
        // Usamos una plantilla de texto (template literal ``) de JavaScript para escribir el CSS.
        // Puedes agregar o modificar cualquier regla de CSS directamente aquí adentro.
        style.innerHTML = `
            /* --- FUENTES Y ESTILOS GLOBALES --- */

            /* Importamos la fuente 'Inter' desde Google Fonts para usarla en toda la página. */
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

            /* Habilitamos el desplazamiento suave (smooth scroll) para toda la página al hacer clic en los enlaces del menú. */
            html {
                scroll-behavior: smooth;
            }

            /* Estilos base para el <body>. Afectan a toda la página. */
            body {
                font-family: 'Inter', sans-serif; /* Establecemos la fuente principal. */
                color: #E2E8F0; /* Color de texto general (un gris claro, slate-200 de Tailwind). */
                background-color: #0F172A; /* Color de fondo principal (un azul oscuro, slate-900 de Tailwind). */
                -webkit-font-smoothing: antialiased; /* Suavizado de fuentes para navegadores WebKit (Chrome, Safari). */
                -moz-osx-font-smoothing: grayscale; /* Suavizado de fuentes para Firefox. */
            }

            /* Esta clase se añade al <body> con JavaScript cuando el modal de contacto está abierto para evitar el scroll de fondo. */
            body.modal-open {
                overflow: hidden;
            }


            /* --- CLASES PARA ANIMACIONES Y COMPONENTES ESPECÍFICOS --- */

            /* Estilo inicial para las secciones que aparecerán con una animación de fundido (fade in). */
            .fade-in-section {
                opacity: 0; /* Empieza totalmente transparente. */
                transform: translateY(20px); /* Ligeramente desplazada hacia abajo para un efecto de subida. */
                transition: opacity 0.6s ease-out, transform 0.6s ease-out; /* Define la duración y el tipo de animación. */
            }

            /* Estilo que se aplica dinámicamente con JavaScript cuando la sección es visible en la pantalla. */
            .fade-in-section.is-visible {
                opacity: 1; /* Se vuelve totalmente opaca. */
                transform: translateY(0); /* Vuelve a su posición original. */
            }

            /* Estilo para el punto decorativo en la línea de tiempo de la sección de experiencia. */
            .timeline-item::before {
                content: ''; /* Obligatorio para que se muestre un pseudo-elemento ::before. */
                position: absolute; /* Se posiciona de forma absoluta respecto a su contenedor (.timeline-item). */
                width: 14px;
                height: 14px;
                border-radius: 50%; /* Lo convierte en un círculo perfecto. */
                left: -2.3rem; /* Lo posiciona a la izquierda, fuera del contenedor del texto, alineado con la línea vertical. */
                top: 0.25rem; /* Ajuste vertical para que quede centrado con el título. */
                background-color: #0F172A; /* El color del centro del círculo (igual al fondo). */
                border: 3px solid #0891B2; /* El color del borde del círculo (cian). */
            }

            /* --- TU CSS PERSONALIZADO --- */
            /*
             * ¡Puedes agregar tus propias clases de CSS aquí!
             * Por ejemplo, si quieres crear un botón con un efecto de brillo:
             *
             * .brillo-boton {
             * box-shadow: 0 0 15px rgba(52, 211, 153, 0.5);
             * transition: box-shadow 0.3s ease-in-out;
             * }
             *
             * .brillo-boton:hover {
             * box-shadow: 0 0 25px rgba(52, 211, 153, 0.8);
             * }
             *
             * Luego, simplemente aplica la clase a cualquier botón en tu JSX: className="... brillo-boton"
            */
        `;
        // --- FIN DE LA EXPLICACIÓN DEL CSS ---

        // Añadimos la etiqueta <style> con todo nuestro CSS al final del <head> del documento.
        document.head.appendChild(style);

        // Esta función se ejecuta cuando el componente se "desmonta" (deja de mostrarse).
        // Limpia la etiqueta <style> para evitar duplicados si el componente se volviera a cargar.
        return () => { document.head.removeChild(style); };
    }, []);
    
    useEffect(() => {
        if (isModalOpen) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }, [isModalOpen]);

    return (
        <div className="bg-slate-900">
            <Header />
            <main className="container mx-auto px-6 pt-24">
                <Hero onContactClick={() => setIsModalOpen(true)} />
                <About />
                <Experience />
                <Projects />
                <Skills />
                <Contact onContactClick={() => setIsModalOpen(true)} />
            </main>
            <Footer />
            <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </div>
    );
}
